export default "__VITE_ASSET__aed82e42__"